
/*global define*/

define('modules/application/popup',[
  'app',
  'jquery',
  'backbone',
  'magnificPopup'
], function (app, $, Backbone) {

  // Create a new module
  var Popup = app.module();

  // Popup Model
  // ----------
  Popup.Model = Backbone.Model.extend({
    defaults: {
      closeButton: true
    }
  });

  // Popup Views
  // ----------

  var ConfirmPopupView = Backbone.View.extend({
        template: JST['app/scripts/templates/Confirm.ejs'],
        tagName: 'section',
        className : 'confirmPopup',
        serialize : function() {return {text:this.options.text};},
        events : {
            'click .yesButton' : 'yesButtonClickedEventHandler',
            'click .noButton'  : 'noButtonClickedEventHandler',
        },

        yesButtonClickedEventHandler : function() {
            window.BticinoCMS.eventAggregator.trigger('confirmResponse:obtained', true);
            $.magnificPopup.close();
        },

        noButtonClickedEventHandler : function() {
            window.BticinoCMS.eventAggregator.trigger('confirmResponse:obtained', false);
            $.magnificPopup.close();
        }
    });

  Popup.View = Backbone.View.extend({
    keep: true,

    events: {
      'click .closeButton': 'closeButtonClickedEventHandler',
      'click .yesButton': 'yesButtonClickedEventHandler',
      'click .noButton': 'noButtonClickedEventHandler'
    },

    serialize: function() {
      return {
        model: this.model,
        app: BticinoS4B.Instances.Models.ApplicationModel
      };
    },

    show: function(openCallback, closeCallback, scope) {
      var that = this;
      this.content = this.$el;
      var colorBoxdata = {
        html: this.content,
        scrolling: false,
        transition: "fade",
        close: "",
        opacity: 0.6,
        speed: 150,
        overlayClose: false,
        escKey: true,

        onComplete: function() {
          $(".closeButton").click(function() {
            that.closeButtonClickedEventHandler();
          });

          if (openCallback)
            setTimeout(function() {
              openCallback.call(scope);
            }, 500);
        },

        onClosed: function() {
          var callback, callbackScope, callbackData;
          if (!closeCallback) {
            if (that.model.get) {
              callback      = that.model.get("callback");
              callbackScope = that.model.get("callbackScope");
              callbackData  = that.model;
            }
          } else {
            callback = closeCallback;
            callbackScope = scope;
            callbackData = undefined;
          }

          if (callback !== undefined) {
            callback.call(callbackScope, callbackData);
          }
        }

      };
      
      if (that.model.get !== undefined) {
        if (that.model.get("closeButton") === false)
          _.extend(colorBoxdata, {
            onLoad: function() {
              $('#cboxClose').hide();
            }
          });
        else
          _.extend(colorBoxdata, {
            onLoad: function() {
              $('#cboxClose').show();
            }
          });
      } else {
        if (that.model.closeButton === false)
          _.extend(colorBoxdata, {
            onLoad: function() {
              $('#cboxClose').hide();
            }
          });
        else
          _.extend(colorBoxdata, {
            onLoad: function() {
              $('#cboxClose').show();
            }
          });
      }
      
      $.colorbox(colorBoxdata);

      var customOption = [];
      customOption.width = 100;
      customOption.height = 100;
      
      $.colorbox.resize();
    },

    hide: function() {
      $.colorbox.close();
    },

    cleanup: function() {
      if(this.model.off)
        this.model.off(null, null, this);
    },

    closeButtonClickedEventHandler: function(event) {
      this.hide();
    },

    yesButtonClickedEventHandler: function(event) {
      window.BticinoS4B.eventAggregator.trigger('confirmResponse:obtained', true);
      this.hide();
    },

    noButtonClickedEventHandler: function(event) {
      window.BticinoS4B.eventAggregator.trigger('confirmResponse:obtained', false);
      this.hide();
    },

    beforeRender: function() {
      if ((this.model) && (!this.model.attributes)) {
        if (this.model !== null)
          this.model = new Popup.Model(this.model);
        else
          this.model = new Popup.Model();
      }
    },

    createPopupHtml: function(_domElement) {
      var popup,
        txt;

      if (_domElement) {
        popup = _domElement;
      } else {
        popup = document.createElement('div');
        txt = document.createTextNode($.i18n._('unableToProceed'));
        popup.appendChild(txt);
      }

      popup.className = 'popup';

      return popup;
    },

    fireAlertMessage: function(title, _domElement) {
      _domElement = $('<section class="popup"><h5>' + title + '</h5>' + '<section style="text-align:center; padding: 10px 0;">' + $(_domElement).html() + '</section></section>');
      var domElement = this.createPopupHtml(_domElement);

      $.magnificPopup.open({
        items: {
          src: domElement
        }
      }, 0);
    },

    fireConfirmMessage: function(text) {
      var confirmView = new ConfirmPopupView({
        text: text
      }),
        domElement, popup;

      popup = document.createElement('div');
      $(popup).append(confirmView.render().el);
      domElement = this.createPopupHtml(popup);

      $.magnificPopup.open({
        items: {
          src: domElement
        },
        showCloseBtn: false
      }, 0);
    },

    fireLoadingPopup: function() {
      var popup = document.createElement('div'),
        htmlToAppend = '<h5>' + $.i18n._('documentGenerationWaitingMessage') + '</h5>' +
          '<section style="text-align:center; padding: 10px 0;">' +
          '<img src="<%=window.BticinoS4B.baseUrl%>images/loader-pdf.gif" alt="Loading" style="margin: auto; width: 60px; height: 60px; margin-bottom: 10px;"/>' +
          '<p class="waitingQuote">' + $.i18n._('documentGenerationWaitingMessage') + '</p>' +
          '</section>';

      $(popup).append(htmlToAppend);
      popup.className = 'popup loaderPopup';

      var domElement = this.createPopupHtml(popup);

      $.magnificPopup.open({
        items: {
          src: domElement
        }
      }, 0);

    },

    fireDownloadPopup: function(documentUrl) {
      var popup = document.createElement('div'),
        htmlToAppend = '<h5>' + $.i18n._('downloadTheDocument') + '</h5>' +
          '<section style="text-align:center; padding: 10px 0;">' +
          '<a class="downloadButton" target="_blank" href="' + window.BticinoDes.documentDownloadURL + documentUrl + '" style="margin:10px 0;">' + $.i18n._('downloadTheDocument') + '</a>' +
          '</section>';

      $(popup).append(htmlToAppend);

      popup.className = 'popup';

      var domElement = this.createPopupHtml(popup);

      $.magnificPopup.open({
        items: {
          src: domElement
        }
      }, 0);
    },

    fireCustomViewPopup: function(viewToShow, closeCallback) {
      var popup = document.createElement('div');

      $(popup).append(viewToShow.render().el);

      popup.className = 'popup';

      var domElement = this.createPopupHtml(popup);

      $.magnificPopup.open({
        items: {
          src: domElement
        },
        callbacks: {
          close: closeCallback
        }
      }, 0);
    }

  });


  // Required, return the module for AMD compliance
  return Popup;

});